export default __webpack_public_path__ + "static/screen_erp_2-1e79a849b310e941c6e616dc0baf4867.png";